import { useTranslation } from 'react-i18next';

const cards = [
  { key: 'products', icon: 'ri-shopping-bag-3-line', color: 'bg-primary-50 text-primary-600' },
  { key: 'guides', icon: 'ri-book-open-line', color: 'bg-accent-50 text-accent-600' },
  { key: 'shipping', icon: 'ri-truck-line', color: 'bg-secondary-100 text-secondary-700' },
  { key: 'safety', icon: 'ri-shield-check-line', color: 'bg-primary-50 text-primary-600' },
];

export default function SpreadsheetSection() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
            {/* Left: Content */}
            <div>
              <span className="inline-block px-3 py-1 bg-primary-100 text-primary-700 text-xs font-semibold rounded-full mb-4">
                CSSBuy Spreadsheet
              </span>
              <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-4">
                {t('spreadsheet_title')}
              </h2>
              <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-8">
                {t('spreadsheet_desc')}
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
                {cards.map((card) => (
                  <div key={card.key} className="flex items-start gap-3 p-4 bg-white rounded-lg border border-background-200">
                    <div className={`w-10 h-10 rounded-lg ${card.color} flex items-center justify-center shrink-0`}>
                      <i className={`${card.icon} w-5 h-5 flex items-center justify-center text-lg`} />
                    </div>
                    <div>
                      <h3 className="font-semibold text-sm text-foreground-900 mb-1">
                        {t(`spreadsheet_card_${card.key}`)}
                      </h3>
                      <p className="text-xs text-foreground-500 leading-relaxed">
                        {t(`spreadsheet_card_${card.key}_desc`)}
                      </p>
                    </div>
                  </div>
                ))}
              </div>

              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white text-sm font-semibold rounded-lg hover:bg-primary-600 transition-colors"
              >
                {t('spreadsheet_cta')}
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
              </a>
            </div>

            {/* Right: Image */}
            <div className="relative">
              <div className="rounded-2xl overflow-hidden border border-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20clean%20modern%20ecommerce%20spreadsheet%20interface%20on%20a%20tablet%20screen%20showing%20a%20grid%20of%20fashion%20product%20cards%20with%20pastel%20color%20accents%20bright%20minimal%20design%20soft%20daylight%20editorial%20photography&width=800&height=1000&seq=spreadsheet-preview-01&orientation=portrait&nocache=true"
                  alt="CSSBuy Spreadsheet Preview"
                  className="w-full h-auto object-cover"
                />
              </div>
              <div className="absolute -bottom-4 -left-4 bg-white rounded-lg border border-background-200 p-4 shadow-lg max-w-[200px]">
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center">
                    <i className="ri-check-line w-4 h-4 flex items-center justify-center text-primary-600 text-sm" />
                  </div>
                  <span className="text-xs font-semibold text-foreground-900">{t('updated')}</span>
                </div>
                <p className="text-xs text-foreground-500">2026-08-30</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}